<template>
  <span
    v-if="eventType"
    class="aircraft-event-type-label"
    :class="`aircraft-event-type-label--${eventType}`"
  >
    {{ $t(eventType === 'audio' ? 'aircraftAudioEvent' : 'aircraftVideoEvent') }}
  </span>
</template>

<script>
export default {
  name: "AircraftEventTypeLabel",
  props: {
    sourceType: {
      type: String,
      default: "video",
    },
  },
  computed: {
    eventType() {
      const sourceType = this.sourceType || "video";
      return sourceType === "audio" || sourceType === "video" ? sourceType : null;
    },
  },
};
</script>

<style scoped>
.aircraft-event-type-label {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  flex-shrink: 0;
  padding: 2px 7px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
}

.aircraft-event-type-label--audio {
  color: #fff;
  background-color: #d92d2d;
}

.aircraft-event-type-label--video {
  color: #302600;
  background-color: #f5c518;
}
</style>
